import ResponseCardView from './ResponseCard.view';
export default ResponseCardView;
